import { render } from "./AddVatTuItemV2.vue?vue&type=template&id=9723cc54&ts=true"
import script from "./AddVatTuItemV2.vue?vue&type=script&lang=ts"
export * from "./AddVatTuItemV2.vue?vue&type=script&lang=ts"

import "./AddVatTuItemV2.vue?vue&type=style&index=0&id=9723cc54&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__